import styled from 'styled-components'

import SwitchStyled from 'components/Global/Switch/styled'

const MenuItem = styled.div`
  display: flex;
  i,
  svg {
    margin-right: 0.7rem;
  }

  color: var(--color-mainText);
  &:hover {
    color: var(--color-strongText);
  }
  ${SwitchStyled} {
    margin-left: auto;
    margin-right: 0;
  }

  .Switch {
    padding-left: 1rem;
  }
`
export default MenuItem
